import Axios from './axiosClient'
import { API_ENDPOINT } from '../constants/apis'
import { AxiosResponse } from 'axios'
import type { SfdcAccount, CsmSummary, CsmBulkMap } from '../types'

export const getSfdcAccount = (
  orgId: string | number
): Promise<AxiosResponse<SfdcAccount>> => {
  return Axios.get(`${API_ENDPOINT}/sfdc/account/${orgId}`)
}

export const getSfdcCsmBulk = (
  orgIds: string[]
): Promise<AxiosResponse<CsmBulkMap>> => {
  return Axios.post(`${API_ENDPOINT}/sfdc/csm/bulk`, { org_ids: orgIds })
}

export const getCsmSummary = (): Promise<AxiosResponse<CsmSummary[]>> => {
  return Axios.get(`${API_ENDPOINT}/sfdc/csm/summary`)
}
